import { useMemo, useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { LayoutProvider, useLayout } from "./LayoutContext";

function getTitle(pathname) {
  if (pathname.includes("/employees")) return "قائمة الموظفين";
  if (pathname.match(/^\/schools\/[^/]+$/)) return "ملف المدرسة التفصيلي";
  if (pathname.startsWith("/schools")) return "جميع المدارس";
  if (pathname.startsWith("/add-school")) return "إضافة مدرسة جديدة";
  if (pathname.startsWith("/finance")) return "الإدارة المالية";
  if (pathname.startsWith("/notifications")) return "مركز التنبيهات";
  if (pathname.startsWith("/home")) return "الشاشة الرئيسية";
  return "برنامج الفارس في سكرتاريا المدارس";
}

function getIcon(pathname) {
  if (pathname.includes("/employees")) return "fa-users";
  if (pathname.match(/^\/schools\/[^/]+$/)) return "fa-id-card";
  if (pathname.startsWith("/schools")) return "fa-school";
  if (pathname.startsWith("/add-school")) return "fa-plus-circle";
  if (pathname.startsWith("/finance")) return "fa-money-bill-wave";
  if (pathname.startsWith("/notifications")) return "fa-bell";
  if (pathname.startsWith("/home")) return "fa-house-chimney";
  return "fa-shield-halved";
}

function DashboardShell() {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { headerContent } = useLayout();

  const title = useMemo(() => getTitle(location.pathname), [location.pathname]);
  const icon = useMemo(() => getIcon(location.pathname), [location.pathname]);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isSidebarOpen]);

  return (
    <div className="dashboard-shell">
      {isSidebarOpen && (
        <button
          type="button"
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
          aria-label="إغلاق القائمة الجانبية"
        />
      )}
      <div className="app-layout">
        <Sidebar
          isMobileOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="content">
          <Topbar
            title={title}
            icon={icon}
            headerContent={headerContent}
            onMenuClick={() => setIsSidebarOpen(true)}
          />
          <div className="page-card anim-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <LayoutProvider>
      <DashboardShell />
    </LayoutProvider>
  );
}

